import { useState } from 'react';
import styled from 'styled-components';
import { format } from 'timeago.js';

const dateFormatter = new Intl.DateTimeFormat('en-US', {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
});

const DateDisplay = (props: {
  created: Date;
  lastEdited: Date;
  default: 'created' | 'lastEdited';
}) => {
  const [mode, setMode] = useState(props.default);
  return (
    <DateWrapper
      onMouseOver={() => {
        if (props.default === 'created') {
          setMode('lastEdited');
        } else {
          setMode('created');
        }
      }}
      onMouseLeave={() => {
        setMode(props.default);
      }}
    >
      {mode === 'created' ? (
        <div>created {dateFormatter.format(new Date(props.created))}</div>
      ) : null}
      {mode === 'lastEdited' ? (
        <div>edited {format(props.lastEdited)}</div>
      ) : null}
    </DateWrapper>
  );
};

const DateWrapper = styled.div`
  display: inline-block;
`;

export default DateDisplay;
